
    import './styles.scoped.css';
    export default {
  "link": "awsui_link_4c84z_1ip88_145",
  "variant-secondary": "awsui_variant-secondary_4c84z_1ip88_211",
  "variant-primary": "awsui_variant-primary_4c84z_1ip88_246",
  "variant-info": "awsui_variant-info_4c84z_1ip88_279",
  "variant-value-large": "awsui_variant-value-large_4c84z_1ip88_314",
  "variant-top-navigation": "awsui_variant-top-navigation_4c84z_1ip88_346",
  "variant-recovery": "awsui_variant-recovery_4c84z_1ip88_381",
  "button": "awsui_button_4c84z_1ip88_414",
  "color-inverted": "awsui_color-inverted_4c84z_1ip88_449",
  "font-size-body-s": "awsui_font-size-body-s_4c84z_1ip88_470",
  "font-size-body-m": "awsui_font-size-body-m_4c84z_1ip88_477",
  "font-size-heading-xs": "awsui_font-size-heading-xs_4c84z_1ip88_483",
  "font-size-heading-s": "awsui_font-size-heading-s_4c84z_1ip88_489",
  "font-size-heading-m": "awsui_font-size-heading-m_4c84z_1ip88_496",
  "font-size-heading-l": "awsui_font-size-heading-l_4c84z_1ip88_503",
  "font-size-heading-xl": "awsui_font-size-heading-xl_4c84z_1ip88_510",
  "font-size-display-l": "awsui_font-size-display-l_4c84z_1ip88_517",
  "font-size-inherit": "awsui_font-size-inherit_4c84z_1ip88_524",
  "icon-wrapper": "awsui_icon-wrapper_4c84z_1ip88_532",
  "icon": "awsui_icon_4c84z_1ip88_532"
};
  